import React, { useState } from "react";
import { usePastPerformancesForPreview } from "@/api/hooks/usePastPerformancesForPreview";
import { usePastPerformancesStore } from "@/stores/pastPerformancesStore";
import { X } from "lucide-react";
import { Loader } from "@/components/ui/Loader";

interface ArtistPremiumPerformanceTableProps {
  hideTitle?: boolean;
  enableDelete?: boolean;
}

const ArtistPremiumPerformanceTable: React.FC<ArtistPremiumPerformanceTableProps> = ({
  hideTitle,
  enableDelete = false,
}) => {
  const { performances } = usePastPerformancesForPreview();
  const deleteItem = usePastPerformancesStore((s) => s.deleteItem);
  const [deletingId, setDeletingId] = useState<number | null>(null);

  return (
    <>
      <div className="px-4 md:mb-28 w-fit">
        {!hideTitle && (
          <h3 className="text-[28px] text-center md:text-[42px] font-bold bg-gradient-to-r from-[#F16B2E] via-[#EC2179] to-[#EC2179] text-transparent bg-clip-text mt-16">
            PAST PERFORMANCES
          </h3>
        )}
        <div className="mt-6 text-sm md:text-base xl:text-2xl xl:px-20">
          <div className="grid grid-cols-3 border-1 border-gray-800 px-2 mb-2">
            <p className="p-1">
              Total Events <br /> Performed
            </p>
            <p className="p-1 w-[25vw] ">Primary Event Type</p>
            <p className="p-1 w-[32vw] ">Popular Ones</p>
          </div>
          {performances.map((item) => {
            const isReal = item.id > 0;
            const canDelete = enableDelete && isReal;
            const isDeleting = deletingId === item.id;

            const handleDelete = async () => {
              if (!canDelete || deletingId !== null) return;
              try {
                setDeletingId(item.id as number);
                await deleteItem(item.id as number);
              } finally {
                setDeletingId(null);
              }
            };

            return (
              <div
                key={item.id}
                className="grid grid-cols-3 border-1 border-gray-800 px-2 mb-2 relative"
              >
                <p className="p-1 opacity-60">{item.event_count}</p>
                <p className="p-1 opacity-60">{item.event_name}</p>
                <p className="p-1 opacity-60 relative">
                  {canDelete && (
                    <button
                      type="button"
                      onClick={handleDelete}
                      disabled={isDeleting}
                      className="absolute top-2 -right-0 z-50 flex h-6 w-6 items-center justify-center rounded-full bg-black/70 text-xs text-white border border-white/40 disabled:opacity-60"
                    >
                      {isDeleting ? <Loader size="small" /> : <X className="h-3 w-3" />}
                    </button>
                  )}
                  {item.desc || "—"}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ArtistPremiumPerformanceTable;
